const commonConstants = {
    LOGOUT: 'COMMON_LOGOUT',

    INSERT_REQUEST: 'COMMON_INSERT_REQUEST',
    INSERT_SUCCESS: 'COMMON_INSERT_SUCCESS',
    INSERT_FAILURE: 'COMMON_INSERT_FAILURE',

    GETALL_REQUEST: 'COMMON_GETALL_REQUEST',
    GETALL_SUCCESS: 'COMMON_GETALL_SUCCESS',
    GETALL_FAILURE: 'COMMON_GETALL_FAILURE',

    GETALL_LOCATION_SUCCESS: 'GETALL_LOCATION_SUCCESS',
    GETALL_COSTUNIT_SUCCESS: 'GETALL_COSTUNIT_SUCCESS',
    GETALL_SUBCATEGORY_SUCCESS: 'GETALL_SUBCATEGORY_SUCCESS',

    GET_FREQUENTCOSTUNITDATA_REQUEST: 'COMMON_GET_FREQUENTCOSTUNITDATA_REQUEST',
    GET_FREQUENTCOSTUNITDATA_SUCCESS: 'COMMON_GET_FREQUENTCOSTUNITDATA_SUCCESS',
    GET_FREQUENTCOSTUNITDATA_FAILURE: 'COMMON_GET_FREQUENTCOSTUNITDATA_FAILURE',

    GET_FREQUENTSUBCATEGORYDATA_REQUEST: 'COMMON_GET_FREQUENTSUBCATEGORYDATA_REQUEST',
    GET_FREQUENTSUBCATEGORYDATA_SUCCESS: 'COMMON_GET_FREQUENTSUBCATEGORYDATA_SUCCESS',
    GET_FREQUENTSUBCATEGORYDATA_FAILURE: 'COMMON_GET_FREQUENTSUBCATEGORYDATA_FAILURE',

    UPDATE_REQUEST: 'COMMON_UPDATE_REQUEST',
    UPDATE_SUCCESS: 'COMMON_UPDATE_SUCCESS',
    UPDATE_FAILURE: 'COMMON_UPDATE_FAILURE',

    DELETE_REQUEST: 'COMMON_DELETE_REQUEST',
    DELETE_SUCCESS: 'COMMON_DELETE_SUCCESS',
    DELETE_FAILURE: 'COMMON_DELETE_FAILURE'
};

export default commonConstants


// WEBPACK FOOTER //
// ./src/_constants/common.constants.js